import { render } from "./WoononVideoWidget.vue?vue&type=template&id=09f947f9&scoped=true"
const script = {}

import "./WoononVideoWidget.vue?vue&type=style&index=0&id=09f947f9&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f947f9"]])

export default __exports__